
import ChatRepository from '@/repositories/ChatRepository'
import i18n from '@/plugins/i18n'
import Vue from 'vue'
import { centerScreen, scrollBottom } from '@/helpers/ui.helpers'
import { uploadFile } from '@/helpers/file.helpers'

const chatStore = {
    namespaced: true,
    state: {
        selectedChat: {
            user: null,
            messages: null
        },
        newMessage: '',
        editingMessage: null,
        showMsgOptions: null,
        messagesPendingReadLabel: 0,
        showDialog: {
            create: false,
            delete: false,
            finish: false,
            cancel: false,
            ePrescription: false,
            dontAttend: false
        },
        refs: {
            messageList: null,
            messageInput: null
        }
    },
    mutations: {
        deleteMessageFromChat (state, msgId) {
            var msgIndex = state.selectedChat.messages.findIndex(x => x.chatMessageId === msgId)
            state.selectedChat.messages.splice(msgIndex, 1) 
        },
        sendMessage (state, data) {
            state.selectedChat.messages.push(data)
        },
        editMessage (state, data) {
            var msgIndex = state.selectedChat.messages.findIndex(x => x.chatMessageId === data.msgId)
            if (msgIndex !== -1) { Vue.set(state.selectedChat.messages, msgIndex, data.msg) }

        },
        toggleShowMsgOptions (state, msgId = null) {
            state.showMsgOptions = msgId
        },
        incrementUnreadMessages (state, amount = 1) {
            if (amount) state.messagesPendingReadLabel += amount
        },
        resetMsg (state) {
            state.editingMessage = null
            state.showMsgOptions = null
            state.newMessage = ''
            state.messagesPendingReadLabel = 0
        },
        setChatInfo (state, data) {
            state.selectedChat.user = data
        },
        setChatMessages (state, data) {
            state.selectedChat.messages = data
        },
        unselectChat (state) {
            state.selectedChat = { user: null, messages: null }
        },
        setNewMessage (state, data) {
            state.newMessage = data
        },
        setEditingMessage (state, data) {
            state.editingMessage = data
        },
        updateEditedMessageProperties (state) {
            state.editingMessage.text = state.newMessage
            state.editingMessage.edited = true
        },
        toggleShowDialog (state, type) {
            state.showDialog[type] = !state.showDialog[type]
        },
        hideAllDialogs (state) {
            state.showDialog = { create: false, delete: false, finish: false, cancel: false, ePrescription: false, dontAttend: false }
        },
        setRefs (state, data) {
            state.refs.messageList = data.msgList
            state.refs.messageInput = data.msgInput
        }
    },
    actions: {
        resetStateOnLoad ({commit}) {
            commit('unselectChat')
            commit('resetMsg')
            commit('hideAllDialogs')
        },
        async sendMessage ({commit, state, rootGetters}, file = null) {
            if ((state.newMessage.trim() !== '' || file !== null) && state.selectedChat) {
                var chatMessage = {
                    AppointmentId: state.selectedChat.user.idAppointment,
                    Text: state.newMessage,
                    ReceiverId: state.selectedChat.user.idUser
                }
                let sentMessage
                if (state.newMessage.trim() !== '') {
                    sentMessage = await ChatRepository.sendMessage(state.selectedChat.user.idAppointment, chatMessage)
                } else if (file != null) {
                    sentMessage = await uploadFile(`chats/${chatMessage.AppointmentId}/messages`, chatMessage, file)
                } else {
                    return
                }
                
                commit('sendMessage', sentMessage.data)
                commit('resetMsg')
                Vue.nextTick(() => {
                    centerScreen(state.refs.messageInput)
                    scrollBottom(state.refs.messageList, true)
                })
                if (state.selectedChat.user.canCancel && rootGetters['session/userIsProfessional'] && state.selectedChat.user.withCompaniesServices) {
                    Vue.set(state.selectedChat.user, 'canCancel', false)
                }
            }
        },
        async editMessage ({commit, state, dispatch}) {
            var editedMessage = {
                Text: state.newMessage
            }
            await ChatRepository.editMessage(state.selectedChat.user.idAppointment, state.editingMessage.chatMessageId, editedMessage).then((response) => {
                if (response.status === 200) {
                    dispatch('showSuccessAlert', i18n.t('chats.edit-message-success'), { root: true })
                    commit('updateEditedMessageProperties')
                } else {
                    dispatch('showDangerAlert', i18n.t('chats.edit-message-fail'), { root: true })
                }
            })
            commit('resetMsg')
        },
        async deleteMessage ({commit, state, dispatch}, msgId) {
            await ChatRepository.deleteMessage(state.selectedChat.user.idAppointment, msgId).then((response) => {
                if (response.status === 200) {
                    commit('deleteMessageFromChat', msgId)
                    commit('toggleShowMsgOptions')
                    dispatch('showSuccessAlert',  i18n.t('chats.delete-message-success'), { root: true })
                } else {
                    dispatch('showDangerAlert',  i18n.t('chats.delete-message-fail'), { root: true })
                }
            })
        }
    }
}

export default chatStore


// WEBPACK FOOTER //
// ./src/store/modules/chat.js